<!-- MODAL HU_064-Mostrar mensaje en Cambio de Ponderación con notas previamente ingresadas -->
<button id="modal-notas-ingresadas-btn" class="btn ocultar-mobile d-none" data-toggle="modal" data-target="#notas-ingresadas">Modal notas ingresadas</button>
<div class="modal fade" id="notas-ingresadas" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header align-items-center">
              <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                  <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
              </button>
          </div>
          <div class="modal-body">
              <form>
                  <div class="row align-items-center my-3 mx-4">
                      <p class="mb-1 ml-3">Existen calificaciones ingresadas previamente. Al modificar el Registro de ponderaciones podría afectar su visualización en el registro de calificaciones.</p>
                      <p class="mb-0 ml-3 text-muted">¿Está seguro/a que desea guardar la modificación?</p>
                  </div>
              </form>
          </div>
          <div class="modal-footer justify-content-center">
              <div class="my-4">
                <button
                  class="boton_secundario_modal ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="SI" alt="SI"
                  (click)="childFunction()"
                  data-dismiss="modal">
                  SI
                </button>
                <button
                  class="boton-primario ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="NO"
                  alt="NO" data-dismiss="modal">
                  NO
                </button>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- FIN MODAL HU_064-Mostrar mensaje en Cambio de Ponderación con notas previamente ingresadas -->